import React from 'react'
import Button from './Button'

/* doc
---
title: SecondaryButton
name: SecondaryButton
category: React - Bulma
parent: Button
---

A `SecondaryButton` is a styled version of the `Button` component and should
be used to indicate important actions. In a group of buttons, only one should
be a `SecondaryButton`.

See `Button` component for full details.

```html_example
  <Secondary href="/somewhere">
    Important Action
  </Secondary>
```
*/
function SecondaryButton(props) {
  const { children, className, ...rest } = props

  const classes = [
    'is-primary',
    className || '',
  ]

  return (
    <Button {...rest} className={classes.join(' ')}>
      {children}
    </Button>
  )
}

export default SecondaryButton
